import { render } from "./CallPage.vue?vue&type=template&id=dd5f2314"
import script from "./CallPage.vue?vue&type=script&lang=js"
export * from "./CallPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__